/* eslint-disable no-undef */
import * as THREE from 'three';
import CameraControls from "camera-controls";
import { useConfigurationStore } from '@/stores/configurationModule';
CameraControls.install({
  THREE
});
export default function useControls(renderer, camera) {
  const configurationStore = useConfigurationStore();
  const {
    boxDepth
  } = storeToRefs(configurationStore);
  const controls = new CameraControls(camera, renderer.domElement);
  controls._target.set(0, 0, 0);

  // zoom limits
  controls.maxDistance = camera.position.z * 3;
  controls.minDistance = camera.position.z / 1.75;
  controls.distance = camera.position.z;
  controls.rotateTo(-Math.PI / 9, Math.PI / 3);

  // disable panning
  controls.mouseButtons.right = null;
  controls.setTarget(0, boxDepth.value / 3, 0);
  return controls;
}